import VueRouter from 'vue-router';

import Auth from './services/Auth';
import store from './store';

// Components
import Landing from './components/Landing.vue';
import Password from './components/Password.vue';
import ResetPassword from './components/ResetPassword.vue';
import Register from './components/Register.vue';
import Score from './components/Score.vue';
import Assignment from './components/Assignment.vue';
import AssignmentGrid from './components/AssignmentGrid.vue';
import LoadAssignment from './components/LoadAssignment.vue';
import EditProfile from './components/EditProfile.vue';
import Privacy from './components/Privacy.vue';
import Disclaimer from './components/Disclaimer.vue';
import Cookies from './components/Cookies.vue';

// Module tests
import SelfTestModule from './components/modules/SelfTestModule.vue';
import InteractiveVideoModule from './components/modules/InteractiveVideoModule.vue';

import CardSorting from './components/modules/games/CardSorting.vue';
import TowerOfHanoi from './components/modules/games/TowerOfHanoi.vue';
import BalloonAnalogueRiskTask from './components/modules/games/BalloonAnalogueRiskTask.vue';

import MiaPreviewTest from './components/MiaPreviewTest.vue';

const routes = [
    {
        name: 'landing',
        path: '/',
        component: Landing
    },
    {
        name: 'password',
        path: '/password',
        component: Password,
    },
    {
        name: 'resetpassword',
        path: '/resetpassword/:code',
        component: ResetPassword,
        props: true,
    },
    {
        name: 'register',
        path: '/register',
        component: Register,
    },
    {
        name: 'score',
        path: '/score/:assignmentCode',
        component: Score,
        props: true,
    },
    {
        name: 'assignment',
        path: '/assignment/:code',
        component: Assignment,
        props: true,
    },
    {
        name: 'assignmentgrid',
        path: '/assignmentgrid',
        component: AssignmentGrid,
    },
    {
        name: 'loadassignment',
        path: '/loadassignment',
        component: LoadAssignment,
    },
    {
        name: 'selftestmodule',
        path: '/selftestmodule',
        component: SelfTestModule,
    },
    {
        name: 'TowerOfHanoi',
        path: '/tower-of-hanoi',
        component: TowerOfHanoi,
    },
    {
        name: 'CardSorting',
        path: '/card-sorting',
        component: CardSorting
    },
    {
        name: 'interactivevideomodule',
        path: '/interactivevideomodule',
        component: InteractiveVideoModule,
    },
    {
        name: 'balloonanaloguerisktask',
        path: '/bart',
        component: BalloonAnalogueRiskTask,
    },
    {
        name: 'miapreview',
        path: '/miapreview',
        component: MiaPreviewTest,
        props: true,
    },
    {
        name: 'editprofile',
        path: '/editprofile',
        component: EditProfile,
    },
    {
        name: 'privacy',
        path: '/privacy',
        component: Privacy,
    },
    {
        name: 'disclaimer',
        path: '/disclaimer',
        component: Disclaimer,
    },
    {
        name: 'cookies',
        path: '/cookies',
        component: Cookies,
    },
    {
        name: 'acceptApplication',
        path: '/accept/:token',
        component: Landing
    }
];

const router = new VueRouter({
    'routes': routes
});

router.beforeEach((to, from, next) =>
{
    //console.log('route to', to);
    
    let loggedIn = Auth.isLoggedIn();
    store.commit('setLoggedIn', loggedIn);

    if(to.name === "miapreview") {
        next();
        return;
    }

    if( to.name === 'landing' ||
        to.name === 'privacy' ||
        to.name === 'disclaimer' ||
        to.name === 'cookies' ||
        to.name === 'acceptApplication') {
        next();
        return;
    }

    if (to.name === 'register' || to.name === 'password' || to.name === 'resetpassword') {
        // If we are logged in, go to main
        if (loggedIn) {
            next('/loadassignment');
            return;
        }
    } else if (to.name == null && loggedIn) {
        next('/loadassignment');
        return;
    } else if (to.meta && !to.meta.allowAnonymous && (to.name !== 'register' || to.name !== 'password' || to.name !== 'resetpassword')) {

        // If we are not logged in, go to login
        if(!loggedIn) {
            next('/');
            return;
        }
    }

    // Go to wherever
    next();
});

export default router;